import {
  UPDATE_CUSTOM_PAYMENT_DATA,
  RESET_CUSTOM_PAYMENT,
  SET_CUSTOM_PAYMENT_ERRORS,
  GETTING_CUSTOM_PAYMENT_LINK,
} from '../../../../types/conversations/plugins'

const customPaymentInitialState = {
  concept: '',
  price: 0,
  commission: 0,
  bondNumber: '',
  total: 0,
  link: '',
  gettingLink: false,
  errors: {},
}

export default function customPayment(state = customPaymentInitialState, action) {
  switch (action.type) {
    case UPDATE_CUSTOM_PAYMENT_DATA: {
      const { data } = action
      return Object.assign({}, state, data)
    }
    case SET_CUSTOM_PAYMENT_ERRORS: {
      const { errors } = action
      return Object.assign({}, state, { errors })
    }
    case GETTING_CUSTOM_PAYMENT_LINK: {
      const { gettingLink } = action
      return Object.assign({}, state, { gettingLink })
    }
    case RESET_CUSTOM_PAYMENT: {
      return customPaymentInitialState
    }
    default: {
      return state
    }
  }
}
